import type {ExportFieldSettings, ExportSettingsTab} from '@/lib/classes/SharedMap/exportFields';

/** Tab icons for marker collections, keyed by filter-collection name (= settings key = tab id). */
const COLLECTION_TAB_ICONS: Record<string, string> = {
  industrialBuildings: 'Navy-Compass-Up',
  industrialProjects: 'Navy-Circle',
  acquisitionProjects: 'Navy-Acquisition',
  multiFamilyProjects: 'Navy-Multi-Family',
  multiFamilyAcquisitionProjects: 'Navy-Multi-Family',
  competitiveBuildings: 'Blue-Balloon-Flat',
  competitivePortfolios: 'Blue-Portfolio-Flat',
  multiFamilyBuildings: 'Purple-Balloon',
  dataCenterBuildings: 'Yellow-Balloon',
  dataCenterProjects: 'Navy-DataCenterProject',
};

/** Tab icons for overlay/SMAPS feature types. */
const FEATURE_TYPE_ICONS: Record<string, string> = {
  polygon: 'Polygon-Icon',
  polyline: 'Polyline-Icon',
  route: 'AccessRoute-Icon',
  png: 'Image-Icon',
  blockPlan: 'BlockPlan-Icon',
  label: 'Label-Icon',
};

interface TabItem {
  type?: string;
  markerData?: {icon?: string};
}

/**
 * Derives the export dialog's tabs from the discovered export settings: every settings key is a tab.
 * Icons resolve from the collection map, then the feature-type map, then the items themselves
 * (comp-view tabs use their marker icon), and finally the key itself (placeMarker keys are icon names).
 */
export function getExportTabs(items: TabItem[], exportFieldSettings: ExportFieldSettings): ExportSettingsTab[] {
  return [...exportFieldSettings.keys()].map((key) => ({
    id: key,
    icon: {
      name: COLLECTION_TAB_ICONS[key]
        ?? FEATURE_TYPE_ICONS[key]
        ?? items.find((item) => item?.type === key)?.markerData?.icon
        ?? key,
    },
  }));
}
